import axios from "axios";

export const ServiceAPI = {
  getAll: function (limit = 9999) {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/service/get`,
      params: {
        limit: limit,
      },
    });
  },
};
